export const SCREEN = {
  LOG_IN: "LOGIN",
  SIGN_UP: "SIGNUP",
  FORGOT_PASSWORD: "FORGOTPASSWORD",
};
